import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";

import "../../styles/resources.css";
import { BmsHeader } from "../../components/main-components/app.header";
import { SkewBox } from "../../components/page/skew";
import { useAuth } from "../../services/authentication/authentication.context";
import { AddButton } from "../../components/utilities/buttons";
import { AppFooter } from "../../components/main-components/footer";
import { AppAlert } from "../../components/utilities/alert";
import { loadAllPastQuestions } from "../../services/documents/documents.context";
import { buttonsData, yearsList } from "../../helpers/mock-data";
import { FieldButton } from "../../components/utilities/field-button";


export const PastQuestionPage = () => {

    const chosenField = useLocation().state?.field;

    const { isAuthenticated, userData } = useAuth()

    const [field, setField] = useState(chosenField);
    const [alertData, setAlertData] = useState();
    const [pQuestions, setPQuestions] = useState([]);
    const [examYr, setexamYr] = useState('');


    const navigateTo = useNavigate();

   

    const getbg = (field) => {
        return buttonsData.find((val) => val.caption === field).background;
    }


    const gotoDocument = (data) => {
        if (!isAuthenticated) {
            setAlertData({
                caption: "Unuathorized!",
                message: "Please sign in to access this video lesson.",
                acceptAction: () => navigateTo("/login"),
                accept: "OK",
                reject: "Cancel",
                rejectAction: () => setAlertData()
            });
            return;
        }
        navigateTo("/questiondoc", { state: { data } })
    }


    useEffect(() => {
        (async () => {
            const data = await loadAllPastQuestions(field);
            if (examYr !== '') {
                let filteredData = data?.filter((question) => question.examYear === parseInt(examYr));
                setPQuestions(filteredData);
                return;
            } else if (examYr === '')
                setPQuestions(data);
        })();
    }, [field, examYr]);

    return (
        <div className="page-body">
            <BmsHeader />
            <SkewBox title={"Past Questions"} background={"/media/resources.jpg"} />
            {alertData && (
                <AppAlert
                    caption={alertData.caption}
                    message={alertData.message}
                    accept={alertData.accept}
                    reject={alertData.reject}
                    acceptAction={alertData.acceptAction}
                    rejectAction={alertData.rejectAction}
                    close={() => setAlertData()}
                />
            )}
            <div>
                <div className="notes-page" style={{ flexDirection: "column" }}>
                    {userData?.role === 'admin' && (
                        <div className="adm-btns">
                            {userData?.superAdmin && (
                                <AddButton caption={"Subscribe user"} link={"/activatehnd"} />
                            )}
                            <AddButton caption={"Add a new document"} link={"/addhndquestion"} />
                        </div>

                    )}
                    <div className="main-page" >
                        <div className="field-caption">
                            Choose field of study
                        </div>

                        <div className="field-buttons-box c-al">
                            {buttonsData.map((data, indx) => (
                                <FieldButton
                                    data={data}
                                    onClick={() => {
                                        setField(data.caption)
                                    }}
                                    key={indx}
                                />
                            ))}
                        </div>
                        <div className="flx-rw yr-cont c-al">
                            <div className="yr-cap">Select Year</div>
                            <div className="yr-box">
                                <select
                                    className="exam-list"
                                    value={examYr}
                                    onChange={(e) => setexamYr(e.target.value)}
                                >
                                    <option value={''}>All years</option>
                                    {yearsList().map((yr) => (
                                        <option value={yr}>{yr}</option>
                                    ))}
                                </select>
                                {examYr !== '' &&
                                    <button
                                        className="canc"
                                        onClick={() => setexamYr('')}
                                    >
                                        <FontAwesomeIcon icon={faClose} color="#ffffff" />
                                    </button>
                                }
                            </div>
                        </div>
                       

                        {pQuestions?.length ? (
                            <div className="p-q-list">
                                {pQuestions?.map((qData, i) => (
                                    <div
                                        className="p-q-unit flx-rw"
                                        onClick={() => { gotoDocument(qData) }}
                                    >
                                        <img
                                            src={getbg(qData.field)}
                                            alt=""
                                            className="field-img"
                                        />
                                        <div className="p-q-top">
                                            <span className="p-q-caption">{qData?.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="field-label">
                                No past questions found in this category
                            </div>
                        )}

                    </div>
                </div>
            </div>

            <AppFooter />
        </div>
    );
}